/* import __COLOCATED_TEMPLATE__ from './details-header-component.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import Component from '@glimmer/component';

export default class DetailsHeaderComponent extends Component {
  constructor() {
    super(...arguments);
  }
}
